import classnames from 'classnames/bind'
import { useRef, useState } from 'react'

import Input, { InputProps } from '~/components/Abstracts/Form/Input'

import uniqueId from '~/utils/unique-id'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type CheckboxProps = InputProps & {
  className?: string
  inputClassName?: string
  contentClassName?: string
  labelClassName?: string
  checkmarkClassName?: string
  checkmarkActiveClassName?: string
  checkmarkActive?: JSX.Element | JSX.Element[] | string | null
  label?: JSX.Element | JSX.Element[] | string
  id?: string
}

function Checkbox({
  className,
  inputClassName,
  contentClassName,
  labelClassName,
  checkmarkClassName,
  checkmarkActiveClassName,
  checkmarkActive,
  errorClassname,
  label,
  disabled,
  id,
  children,
  type = 'checkbox',
  ...inputProps
}: CheckboxProps) {
  const [error, setError] = useState(null)
  const idRef = useRef(uniqueId())

  const cssError =
    (inputProps.withError || error?.type || error?.types?.length > 0) &&
    inputProps.withError
      ? errorClassname
      : null

  return (
    <label
      className={cx(css.Checkbox, className, cssError, { disabled })}
      htmlFor={id}>
      <Input
        type={type}
        id={id}
        className={cx(inputClassName, css.input)}
        onError={(err) => setError(err)}
        {...inputProps}
      />
      <div className={cx(contentClassName, css.contentClassName)}>
        <span className={cx(css.checkmark, checkmarkClassName, cssError)}>
          <span
            className={cx(
              css.checkmarkActive,
              checkmarkActiveClassName,
              cssError,
            )}>
            {checkmarkActive ?? null}
          </span>
        </span>
        <span className={cx(css.label, cssError, labelClassName)}>{label}</span>
      </div>
    </label>
  )
}

Checkbox.defaultProps = {}

export default Checkbox
